import * as TYPES from './types'

/**
 * Default LiveData State
 */
export const defaultState:TYPES.LiveDataState = {
    socket: null as any,
    projectsData:{}
}

// define initial state object
const initialState: TYPES.LiveDataState = {
  socket: defaultState.socket,
  projectsData: defaultState.projectsData
}

// define Live Data reducer
export function liveDataReducer (
  state = initialState,
  action: TYPES.LiveDataActionTypes
): TYPES.LiveDataState {
  switch (action.type) {
    case TYPES.LIVEDATA_CONNECT: {
      return {
        ...state,
        ...{ socket:action.payload.socket },
        ...{ projectsData:defaultState.projectsData }
      }
    }
    case TYPES.LIVEDATA_DISCONNECT: {
      return {
        ...state,
        ...{ socket:defaultState.socket },
        ...{ projectsData:defaultState.projectsData }
      }
    }
    case TYPES.LIVEDATA_UPDATE: {
      return {
        ...state,
        ...{ projectsData:action.payload.projectsData}
      }
    }
    default:
      return state
  }
}
